import {AxiosError} from 'axios';
import {PUT_UPDATE_ADMIN_PROFILE_URL} from 'web-library/constants/apiUrls';
import {UpdateAdminProfileRequest} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutUpdateAdminProfile = ({onError, onSuccess, uuid}: Input) => {
  const putUpdateAdminProfile = async (reqBody: UpdateAdminProfileRequest) => {
    const res = await axiosClient.put<void>(PUT_UPDATE_ADMIN_PROFILE_URL(uuid), reqBody);

    return res.data;
  };

  return useCustomMutation(putUpdateAdminProfile, {
    onSuccess,
    onError,
  });
};
